import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "./ui/dialog";

const API = process.env.REACT_APP_BACKEND_URL;

/** Αλλαγή κωδικού συνδεδεμένου χρήστη (μενού χρήστη). */
export const ChangePasswordDialog = ({ open, onOpenChange }) => {
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (f.next.length < 8) return setError("Ο νέος κωδικός πρέπει να έχει τουλάχιστον 8 χαρακτήρες.");
    if (f.next !== f.confirm) return setError("Οι νέοι κωδικοί δεν ταιριάζουν.");
    setLoading(true); setError("");
    try {
      const r = await axios.post(`${API}/api/auth/change-password`, { current_password: f.current, new_password: f.next });
      toast.success(r.data?.message || "Ο κωδικός άλλαξε");
      setF({ current: "", next: "", confirm: "" });
      onOpenChange(false);
    } catch (err) { setError(err.response?.data?.detail || "Σφάλμα"); }
    finally { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="change-password-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><KeyRound className="w-5 h-5" />Αλλαγή κωδικού</DialogTitle>
          <DialogDescription>Εισάγετε τον τρέχοντα κωδικό σας και τον νέο (τουλάχιστον 8 χαρακτήρες).</DialogDescription></DialogHeader>
        <form onSubmit={submit} className="space-y-4" data-testid="change-password-form">
          <div className="space-y-1.5"><Label htmlFor="cp-current">Τρέχων κωδικός</Label><Input id="cp-current" type="password" value={f.current} onChange={(e) => setF({ ...f, current: e.target.value })} required autoComplete="current-password" data-testid="cp-current" /></div>
          <div className="space-y-1.5"><Label htmlFor="cp-next">Νέος κωδικός</Label><Input id="cp-next" type="password" value={f.next} onChange={(e) => setF({ ...f, next: e.target.value })} required minLength={8} autoComplete="new-password" data-testid="cp-next" /></div>
          <div className="space-y-1.5"><Label htmlFor="cp-confirm">Επιβεβαίωση νέου κωδικού</Label><Input id="cp-confirm" type="password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} required minLength={8} autoComplete="new-password" data-testid="cp-confirm" /></div>
          {error && <p className="text-sm text-red-600" data-testid="cp-error">{error}</p>}
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} data-testid="cp-cancel">Άκυρο</Button>
            <Button type="submit" disabled={loading} data-testid="cp-submit">{loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <KeyRound className="w-4 h-4 mr-2" />}Αποθήκευση</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
